@if (available()) {
  <section aria-label="Saved content" class="mt-6 rounded border border-border p-6">
    <h3>Saved version {{ version() }}</h3>
    @if (loading()) {
      <p role="status">Loading saved content…</p>
    }
    @if (failure()) {
      <p role="alert">{{ failure() }}</p>
      <button type="button" (click)="retry()">Retry</button>
    }
    @if (saved(); as saved) {
      <h4>{{ saved.title }}</h4>
      @if (saved.description !== null) {
        <p class="whitespace-pre-wrap">{{ saved.description }}</p>
      }
      <p class="text-sm text-subdued">Text preview</p>
      @if (renderedBody()) {
        <div data-saved-body class="whitespace-pre-wrap" aria-label="Saved body">{{ renderedBody() }}</div>
      } @else if (saved.body) {
        <p>This saved body has no text.</p>
      } @else {
        <p>No body</p>
      }
    }
  </section>
}
